import { render, staticRenderFns } from "./preformatted-grid.vue?vue&type=template&id=b747059c&scoped=true&"
import script from "./preformatted-grid.ts?vue&type=script&lang=ts&"
export * from "./preformatted-grid.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-grid.scss?vue&type=style&index=0&id=b747059c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b747059c",
  null
  
)

export default component.exports